// extracted by css-extract-rspack-plugin
export default {"workbench":"WWyte","panels":"eQFkP","panel":"bqDVc","hidden":"Bho7O"};